import closeIcon from "../../assets/close-icon.png";
import { useLanguage, getCustomsAgentManagementTranslation } from '../../hooks/useLanguage';

export const AddorEditAgent = ({ handleSubmit, handleChange, isEditing, closeModal, formData, isLoading }) => {
  const [isSpanish] = useLanguage();
  return (
<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-999">
          <div className="bg-white p-8 rounded-lg shadow-lg min-w-[650px]">
            <div className='flex justify-between items-center mb-4'>
              <h2 className='text-2xl font-bold '>{isEditing ? getCustomsAgentManagementTranslation('editAgent', isSpanish) : getCustomsAgentManagementTranslation('addAgent', isSpanish)}</h2>
              <img className='h-6 w-6 cursor-pointer' src={closeIcon} onClick={closeModal} alt="Close" />
            </div>

            <form onSubmit={handleSubmit}>
              <div className='flex flex-col'>
                <div className="form-group flex-1">
                  <label htmlFor="name">{getCustomsAgentManagementTranslation('agentName', isSpanish)}</label>
                  <input
                    type="text"
                    name="nombre"
                    placeholder={getCustomsAgentManagementTranslation('agentName', isSpanish)}
                    className="form-input border-container-force"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group flex-1">
                  <label htmlFor="tax_id">{getCustomsAgentManagementTranslation('agentTaxId', isSpanish)}</label>
                  <input
                    type="text"
                    name="nif"
                    placeholder={getCustomsAgentManagementTranslation('agentTaxId', isSpanish)}
                    className="form-input border-container-force"
                    value={formData.nif}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group flex-1">
                  <label htmlFor="eori">{getCustomsAgentManagementTranslation('agentEori', isSpanish)}</label>
                  <input
                    type="text"
                    name="eori"
                    placeholder={getCustomsAgentManagementTranslation('agentEori', isSpanish)}
                    className="form-input border-container-force"
                    value={formData.eori}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group flex-1">
                  <label htmlFor="address">{getCustomsAgentManagementTranslation('agentAddress', isSpanish)}</label>
                  <input
                    type="text"
                    name="direccion"
                    placeholder={getCustomsAgentManagementTranslation('agentAddress', isSpanish)}
                    className="form-input border-container-force"
                    value={formData.direccion}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className='flex gap-4'>
                  <div className="form-group flex-1">
                    <label htmlFor="city">{getCustomsAgentManagementTranslation('agentCity', isSpanish)}</label>
                    <input
                      type="text"
                      name="localidad"
                      placeholder={getCustomsAgentManagementTranslation('agentCity', isSpanish)}
                      className="form-input border-container-force"
                      value={formData.localidad}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group flex-1">
                    <label htmlFor="country">{getCustomsAgentManagementTranslation('agentCountry', isSpanish)}</label>
                    <input
                      type="text"
                      name="pais"
                      placeholder={getCustomsAgentManagementTranslation('agentCountry', isSpanish)}
                      className="form-input border-container-force"
                      value={formData.pais}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className='flex mt-4'>
                  <button
                    type="submit"
                    className='border bg-default text-white rounded-full py-2 px-5 text-sm'
                    disabled={isLoading}
                  >
                    {isLoading ? getCustomsAgentManagementTranslation('processing', isSpanish) : isEditing ? getCustomsAgentManagementTranslation('updateAgent', isSpanish) : getCustomsAgentManagementTranslation('addAgent', isSpanish)}
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className='py-2 px-2 text-sm ml-2'
                    disabled={isLoading}
                  >
                    {getCustomsAgentManagementTranslation('cancel', isSpanish)}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
  )
}